import React from "react";
import { Navigate, Outlet, useLocation, useNavigate } from "react-router-dom";
import Header from "../Components/Header";
import NavBar from "../Components/NavBar";
import useAuth from "../useAuth";

export default function EntryPage() {
  const { user } = useAuth();
  const location = useLocation();
  const pathname = location.pathname.split("/")[2];

  if (!user) {
    return <Navigate to="/login" />;
  }
  return (
    <div className="min-h-screen flex">
      <div className="w-72 z-30 fixed top-0 hidden lg:block">
        <div className="h-screen shadow-r-xl bg-gradient-to-t bg-[#303641] border-r">
          <div className="h-[calc(100vh)] overflow-y-scroll">
            <NavBar />
          </div>
        </div>
      </div>

      <div className={`lg:ml-72 w-full bg-slate-300}`}>
        <div className="sticky z-30 top-0">
          <Header />
        </div>
        <div className="p-4 min-h-screen z-10 text-gray-600">{<Outlet />}</div>
        {pathname !== "grievancesMsgs" && (
          <div className="px-4 py-4 border-t-[0.1px] text-xs text-slate-900 mx-4 border-gray-400">
            COPYRIGHT - BRAVISHMAH INFOTECH PRIVATE LIMITED
          </div>
        )}
      </div>
    </div>
  );
}
